import React, { Fragment, useState, useContext, useEffect, useRef } from "react";
import Login from "./Login";
import Signup from "./Signup";
import { LayoutContext } from "../index";
import { IoClose } from "react-icons/io5";

const LoginSignup = (props) => {
  const { data, dispatch } = useContext(LayoutContext);

  const [login, setLogin] = useState(true);
  const dialogRef = useRef(null);

  const loginSignupModalToggle = () =>
    data.loginSignupModal
      ? dispatch({ type: "loginSignupModalToggle", payload: false })
      : dispatch({ type: "loginSignupModalToggle", payload: true });

  // Close on Escape and focus the dialog when opened
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape" && data.loginSignupModal) {
        loginSignupModalToggle();
        dispatch({ type: "loginSignupError", payload: false });
      }
    };
    if (data.loginSignupModal) {
      dialogRef.current?.focus();
      window.addEventListener("keydown", onKeyDown);
    }
    return () => window.removeEventListener("keydown", onKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.loginSignupModal]);

  return (
    <Fragment>
      {/* Backdrop Overlay avec meilleure transparence */}
      <div
        onClick={(e) => loginSignupModalToggle()}
        className={`fixed inset-0 z-40 w-full h-screen bg-black/50 backdrop-blur-md cursor-pointer transition-all duration-300 ${
          data.loginSignupModal ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      ></div>

      {/* Signup Login Component Render */}
      <section
        className={` ${
          data.loginSignupModal ? "" : "hidden"
        } fixed z-50 inset-0 my-2 md:my-8 flex items-center justify-center overflow-auto p-2 md:p-4`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="auth-dialog-title"
        tabIndex={-1}
        ref={dialogRef}
      >
        <div className="w-[95%] max-w-sm md:max-w-md relative bg-white rounded-2xl md:rounded-3xl shadow-2xl border-2 border-blue-200 p-4 md:p-6 lg:p-8 transform transition-all duration-300 scale-100 animate-fade-in max-h-[98vh] overflow-y-auto">
          
          {/* Close button - Modern design */}
          <button
            aria-label="Fermer"
            onClick={(e) => {
              loginSignupModalToggle();
              dispatch({ type: "loginSignupError", payload: false });
            }}
            className="absolute top-2 right-2 md:top-4 md:right-4 p-2 md:p-2.5 rounded-full bg-gray-100 hover:bg-red-100 hover:text-red-600 transition-all duration-200 group z-10 shadow-md"
          >
            <IoClose className="w-5 h-5 md:w-6 md:h-6 group-hover:rotate-90 transition-transform duration-300" />
          </button>

          {/* Logo ou illustration */}
          <div className="flex justify-center mb-4 md:mb-6 relative">
            <div className="relative w-16 h-16 md:w-20 md:h-20 bg-blue-600 rounded-full flex items-center justify-center shadow-xl transform hover:scale-110 transition-transform duration-300">
              <svg className="w-10 h-10 md:w-12 md:h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
          </div>

          {/* Header avec titre */}
          <div className="text-center mb-4 md:mb-6 relative">
            <h2 id="auth-dialog-title" className="text-xl md:text-2xl lg:text-3xl font-black text-blue-800 mb-2">
              {login ? "✨ Bon retour !" : "🎉 Rejoignez-nous"}
            </h2>
            <p className="text-xs md:text-sm text-gray-600 font-medium">
              {login ? "Connectez-vous pour accéder à votre compte" : "Créez votre compte en quelques secondes"}
            </p>
          </div>

          {/* Toggle buttons */}
          <div className="flex items-center justify-center mb-4 md:mb-8">
            <div className="inline-flex bg-gray-100 rounded-full p-1 md:p-1.5 shadow-inner relative w-full max-w-xs">
              {/* Sliding background */}
              <div 
                className={`absolute top-1 md:top-1.5 h-[calc(100%-0.5rem)] md:h-[calc(100%-0.75rem)] w-[calc(50%-0.25rem)] md:w-[calc(50%-0.375rem)] bg-blue-600 rounded-full shadow-lg transition-all duration-300 ease-out ${
                  login ? 'left-1 md:left-1.5' : 'left-[calc(50%+0.25rem)] md:left-[calc(50%+0.375rem)]'
                }`}
              ></div>
              <button
                onClick={() => setLogin(true)}
                className={`relative z-10 flex-1 px-4 md:px-8 py-2 md:py-2.5 rounded-full text-xs md:text-sm lg:text-base font-bold transition-all duration-300 ${
                  login 
                    ? "text-blue-600" 
                    : "text-gray-700 hover:text-gray-900"
                }`}
              >
                Connexion
              </button>
              <button
                onClick={() => setLogin(false)}
                className={`relative z-10 flex-1 px-4 md:px-8 py-2 md:py-2.5 rounded-full text-xs md:text-sm lg:text-base font-bold transition-all duration-300 ${
                  !login 
                    ? "text-blue-600" 
                    : "text-gray-700 hover:text-gray-900"
                }`}
              >
                Inscription
              </button>
            </div>
          </div>

          {/* Form content with animation */}
          <div className="transition-all duration-300 animate-fade-in">
            {login ? <Login /> : <Signup />}
          </div>

          {/* Footer avec liens */}
          <div className="mt-4 md:mt-6 pt-3 md:pt-4 border-t-2 border-gray-200 text-center">
            <p className="text-xs text-gray-500 leading-relaxed">
              En continuant, vous acceptez nos{" "}
              <a href="/terms" className="text-blue-600 hover:text-blue-800 font-semibold hover:underline transition-colors">
                Conditions d'utilisation
              </a>
              {" "}et notre{" "}
              <a href="/privacy" className="text-blue-600 hover:text-blue-800 font-semibold hover:underline transition-colors">
                Politique de confidentialité
              </a>
            </p>
          
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default LoginSignup;
